"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var retrieveStyle = function retrieveStyle(theme) {
  return {
    base: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'base', 'backgroundColor']),
      borderRadius: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'base', 'borderRadius']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'base', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'base', 'hover', 'backgroundColor'])
      }
    },
    secondary: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'secondary', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'secondary', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'secondary', 'hover', 'backgroundColor'])
      }
    },
    alternative: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'alternative', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'alternative', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'alternative', 'hover', 'backgroundColor'])
      }
    },
    gray: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'gray', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'gray', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'gray', 'hover', 'backgroundColor'])
      }
    },
    disabled: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'disabled', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'disabled', 'color'])
    },
    small: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'small'])
    },
    large: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'large'])
    },
    labelFullWidth: {
      width: '100%'
    },
    loading: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTIconButton', 'loading', 'color'])
    },
    imgIcon: {
      padding: '10px',
      '&:hover': {
        backgroundColor: '#e2e2e2',
        borderRadius: '50%'
      }
    }
  };
};

exports.retrieveStyle = retrieveStyle;